import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Prispevok} from '../model/Prispevok';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule, MatIconButton} from '@angular/material/button';
import {HttpClient} from '@angular/common/http';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-podpora-prispevok',
    imports: [
        MatIconModule,
        MatMenuModule,
        MatIconButton,
        CommonModule,
        MatButtonModule
    ],
    templateUrl: './podpora-prispevok.component.html',
    styleUrl: './podpora-prispevok.component.css'
})
export class PodporaPrispevokComponent
{
    @ViewChild('editableDiv') inputElement!: ElementRef;

    @Input() p!: Prispevok;
    @Output() change = new EventEmitter();
    isEditable = false;
    private text: string;
    @Input() display = 'large';

    constructor(private http: HttpClient) {
    }

    delete(p: Prispevok): void
    {
        this.http.post('/ais/rest/portal/prispevok-del/' + p.id, null)
            .subscribe({
                next: () => {
                    this.change.next(null);
                },
                error: (err) => {
                  console.error(err);
                }
            });
    }

    onInputChange($event: any)
    {
        this.text = $event.target.innerText;
    }

    update(): void
    {
        this.http.post('/ais/rest/portal/prispevok/' + this.p.id, this.text)
            .subscribe({
                next: () => {
                    this.change.next(null);
                },
                error: (err) => {
                    console.error(err);
                }
            });
    }

    setEditOn() {
        this.isEditable = true;
        this.inputElement.nativeElement.focus();
    }

    cancelEdit() {
        this.isEditable = false;
        this.inputElement.nativeElement.innerHTML = this.p.text;
    }

    // metoda sluzi na sformatovanie casu do medzinarodneho formatu ISO 8601, aby ho vedela spracovat "DatePipe"
    // (lebo inak to pri starsich Apple zariadeniach (napr. iPhone 8) vypisovalo chybu)
    getCas(casIN: string) {
      return casIN.replace(' ', 'T');
    }
}
